export default __webpack_public_path__ + "static/media/sh-ta.80a6ce01.svg";